import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonAddToFrequentProject(props) {
    const map = useMapContext()
    const {mapTypeCode, prjId} = map.data

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => runAsync(
        () => http.post('/commonlyUsedProject/addProject', {pkid: prjId}),

        {
            action: '加入常用项目',
            success: {show: true},
        }
    )

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            加入常用项目
        </MenuButton>
    )
}
